interface UseCourtGridTableProps {
  displayedCourts: any[];
  visibleHours: string[];
  hasPastHours: boolean;
}

export default function useCourtGridTable({ displayedCourts, visibleHours, hasPastHours }: UseCourtGridTableProps) {
  const getGridTemplateColumns = () => {
    const timeColumnWidth = window.innerWidth <= 480 ? 80 : window.innerWidth <= 768 ? 100 : 120;
    return `${timeColumnWidth}px repeat(${displayedCourts.length}, 1fr)`;
  };

  return {
    getGridTemplateColumns,
    displayedCourts,
    visibleHours,
    hasPastHours,
  };
}
